import FALLBACKLogo from "../../assets/svg/assets/FALLBACK.svg";
import { getAssetLogo } from "../../utils/asset/assets";
import { AssetResponse } from "../../utils/asset";
import { AllCollaterals } from "../../constants/addresses";

export const TRANSPARENT_PLACEHOLDER =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";

const isExternalUrl = (url?: string) => /^https?:\/\//i.test(url || "");

export function getExportSafeAssetLogo(asset?: AssetResponse | AllCollaterals) {
  const logo = getAssetLogo(asset);
  return isExternalUrl(logo) ? FALLBACKLogo : logo;
}

// ---------------------------------------------------------------------------
// Card layout dimensions
// ---------------------------------------------------------------------------

export const CARD_DIMS = {
  landscape: { width: 320, height: 200 },
  portrait: { width: 220, height: 310 },
} as const;
